import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysAgo'
})
export class DaysAgoPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) return value;

    const today = new Date();
    const inputDate = new Date(value);
    const difference = today.getTime() - inputDate.getTime();
    const days = Math.floor(difference / (1000 * 3600 * 24));
    const hours = Math.floor((difference % (1000 * 3600 * 24)) / (1000 * 3600));

    if (days === 0) {
      if (hours === 0) {
        return 'Преди по-малко от час';
      } else if (hours === 1) {
        return 'Преди един час';
      } else {
        return `Преди ${hours} часа`;
      }
    } else if (days === 1) {
      return 'Вчера';
    } else {
      return `Преди ${days} дни`;
    }
  }
}
